module.exports = __webpack_public_path__ + "static/ai-2c6c1a20d35e83c533de5bf275ae0720.svg";